module.exports = __webpack_public_path__ + "media/images/mailer/badge_googleplay-light-974a145eb7ab1879fb2821f21b22e274.png";